import { IInquiry } from "pages/InquiryBoxList/InquiryBoxList";
import { atom } from "recoil";
import { ICompanyCategory } from "store/data/company";
import {
  ICompanyEvent,
  ICompanyLocationFilter,
  IWeddingHallFilter,
} from "store/data/data";

export const companyCategoryState = atom<ICompanyCategory[]>({
  key: "companyCategoryState",
  default: [],
});

export const companyLocationFilterState = atom<ICompanyLocationFilter[]>({
  key: "companyLocationFilterState",
  default: [],
});

export const companyWeddingFilterState = atom<IWeddingHallFilter>({
  key: "companyWeddingFilterState",
  default: {},
});

export const companyEventListState = atom<ICompanyEvent[]>({
  key: "companyEventListState",
  default: [],
});

export const recombinationListState = atom<IInquiry[]>({
  key: "recombinationListState",
  default: [],
});

export const etcRecombinationListState = atom<IInquiry[]>({
  key: "etcRecombinationListState",
  default: [],
});
